module.exports = __webpack_public_path__ + "img/symrise-logo-white.72cd2e45.svg";